import React, { memo, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { getMessage } from 'util/locale';
import { Dropdown } from '@tcc/crate';
import { AGRONOMIC_SEASONS_BY_COUNTRY, SEASONS_NAMES_BY_CODE } from 'constants/advanced';
import { SUPPORTED_COUNTRIES } from 'constants/countryCodes';

export const SeasonInput = memo(function SeasonInput() {
  const { control } = useFormContext();

  const seasons = useMemo(() => AGRONOMIC_SEASONS_BY_COUNTRY[SUPPORTED_COUNTRIES.BRAZIL], []);
  const options = useMemo(() => seasons?.map((season) => ({
    value: getMessage(`season__${season}`),
    id: SEASONS_NAMES_BY_CODE[season]
  })), [seasons]);

  return (
    <Controller
      control={control}
      name="season"
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <Dropdown
            options={options}
            label={getMessage('season-variable')}
            placeholder={getMessage('placeholder-text__select-season')}
            testId="season-select"
            setValue={(_: string, id: string) => {
              onChange(id);
            }}
            value={getMessage(`season__${value?.substring(0, 3)}`)}
            error={error?.message}
            width="100%"
          />
        );
      }}
    />
  );
});
